import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectContractHistory } from '../../redux/contract/selectors';
import {columnas} from "../../Constantes/constantesColumnasTablas";
import Table from "../table/Table"
import {Comment} from "../common/Comment"
import { convertToLocalTime, _base64ToArrayBuffer } from "../../commonFunctions/commonFunctions";
import { baseRequest } from "../../fetch/basicThunk";
import { QUERY_GET_DOWNLOAD_FILE } from "../../fetch/constantQueries";
import saveAs from 'file-saver';
import { openModal } from "../../redux/modal/modalSlice";
import { errorHandler } from "../../commonFunctions/errorHandler";

function HistoricComments(data){
    const dispatch = useDispatch();

      async function downloadFile(blobFileGuid) {
        try {
            const data = await baseRequest({param: `${blobFileGuid}`}, dispatch, QUERY_GET_DOWNLOAD_FILE, "GET");
            if (data != "") {
                saveAs(new Blob([ _base64ToArrayBuffer(data.fileBinary)], { type: data.contentType }), data.fileName);
            } else {
                dispatch(openModal({ type: "warning", message:"Erro ao baixar arquivo."}));
            }  
        } catch (error) {
            dispatch(openModal(errorHandler(error)));
        } finally{
        }
    }
    return(
        <div className="datagrid-comment-container">
        {data.data.data.comments.map((e, i)=>
            <Comment key={`${data.caseId}-comment-${i}`} message={e.message} agent={e.agent} state={e.state} date={e.date} files={e.files} downloadFile={downloadFile} />
        )}
       </div>
        )
}

function HistoricCases(){
    const historicCases = useSelector(selectContractHistory)



    function localizeDates(caselist){
        if(caselist){
         const localizedDates = caselist.map((e)=> {
            const local = {...e, creationDate: convertToLocalTime(e.creationDate), closeDate: convertToLocalTime(e.closeDate)};
            return local
          })
          return localizedDates}
    }

    return (
        <Table enableSorting={false} datasource={localizeDates(historicCases)?.filter((e)=>!e.active || e.showCurrent)} columnasTabla={columnas["Historico"]} master masterDetail={HistoricComments}/>
    )
}

export {HistoricCases}